import React from 'react'
import PropTypes from 'prop-types'
import TagBrandForm from '../../TagBrandNew/components/TagBrandForm'
import TagBrandHistories from './TagBrandHistories'

const TagBrandEditPage = ({ idTagBrand }) => {
  return (
    <TagBrandForm idTagBrand={idTagBrand}>
      {/* TagBrandHistories sẽ được hiển thị bên dưới form */}
      <TagBrandHistories idTagBrand={idTagBrand} />
    </TagBrandForm>
  )
}

TagBrandEditPage.propTypes = {
  idTagBrand: PropTypes.string.isRequired
}

export default TagBrandEditPage